import Image from 'next/image';
import { useRangeContext } from './RangeContext';
import { Grid } from '@/src/packages/components/ui/GridBox';
import { Box } from '@/src/packages/components/ui/Box';
import { Heading } from '@/src/packages/components/ui/Heading';
import { Paragraph } from '@/src/packages/components/ui/Paragraph';
import { FadeIn } from '@/src/packages/components/ui/Animations';

export const RangeMasthead = () => {
  const { range } = useRangeContext();

  return (
    <FadeIn>
      <Grid className="-mx-gutter lg:mx-0">
        <Box
          position="relative"
          className="aspect-[4/3] lg:aspect-square"
          colSpan={{ initial: 12, lg: 6 }}
        >
          <Image
            src={range.fields.cover.fields.file.url}
            fill
            priority
            alt={range.fields.name}
            className="object-cover"
            sizes="(max-width: 1024px) 100vw, 50vw"
          />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          colSpan={{ initial: 12, lg: 6 }}
          className="px-gutter pb-16 pt-8"
        >
          <Box className="mx-auto lg:max-w-lg">
            <Heading
              as="h1"
              className="text-3xl"
              marginBottom={3}
              fontWeight="medium"
              fontFamily="serif"
            >
              {range.fields.name}
            </Heading>
            <Paragraph marginBottom={6}>{range.fields.description}</Paragraph>
          </Box>
        </Box>
      </Grid>
    </FadeIn>
  );
};
